import { HStack, Text } from "@chakra-ui/react"
import type { ReactNode } from "react"

type DocumentFieldRowProps = {
  label: string
  labelColor: string
  children: ReactNode
  align?: "start" | "center"
}

export default function DocumentFieldRow({
  label,
  labelColor,
  children,
  align = "center",
}: DocumentFieldRowProps) {
  return (
    <HStack align={align} spacing={3}>
      <Text minW="160px" maxW="160px" color={labelColor} fontSize="sm">
        {label}
      </Text>
      {children}
    </HStack>
  )
}
